(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hp_content_editorial_split"] && !Shopify.designMode) return;
  try {
    
(() => {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.hp-editorial').forEach((el) => obs.observe(el));

  // Subtle parallax on the media (when user prefers motion)
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  const medias = document.querySelectorAll('.hp-editorial__img');
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      medias.forEach((img) => {
        const rect = img.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        if (rect.bottom < 0 || rect.top > vh) return;
        const progress = (vh - rect.top) / (vh + rect.height);
        const offset = (progress - 0.5) * 24;
        img.style.transform = `scale(1.04) translateY(${offset}px)`;
      });
      ticking = false;
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_content_faq_tabbed"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.hp-faq').forEach((root) => {
    // Tabs
    const tabs = root.querySelectorAll('[data-tab]');
    const indicator = root.querySelector('[data-indicator]');
    const panels = root.querySelectorAll('[data-panel]');

    const positionIndicator = (tab) => {
      if (!indicator || !tab) return;
      indicator.style.width = `${tab.offsetWidth}px`;
      indicator.style.transform = `translateX(${tab.offsetLeft - 6}px)`;
    };

    if (tabs.length && indicator) {
      const initial = root.querySelector('.hp-faq__tab.is-active') || tabs[0];
      requestAnimationFrame(() => positionIndicator(initial));
      window.addEventListener('resize', () => {
        const active = root.querySelector('.hp-faq__tab.is-active');
        positionIndicator(active);
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.dataset.tab;
        tabs.forEach((t) => {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach((p) => {
          p.classList.toggle('is-active', p.dataset.panel === id);
        });
        positionIndicator(tab);
      });
    });

    // Accordion (one open at a time)
    const items = root.querySelectorAll('.hp-faq__item');
    items.forEach((item) => {
      const row = item.querySelector('.hp-faq__row');
      const wrap = item.querySelector('.hp-faq__a-wrap');
      if (!row || !wrap) return;

      row.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        // Close any other open in the same panel
        const panel = item.closest('.hp-faq__panel') || item.closest('.hp-faq__list');
        if (panel) {
          panel.querySelectorAll('.hp-faq__item.is-open').forEach((other) => {
            if (other === item) return;
            const otherWrap = other.querySelector('.hp-faq__a-wrap');
            other.classList.remove('is-open');
            other.querySelector('.hp-faq__row').setAttribute('aria-expanded', 'false');
            if (otherWrap) {
              otherWrap.style.height = otherWrap.scrollHeight + 'px';
              requestAnimationFrame(() => { otherWrap.style.height = '0px'; });
              otherWrap.addEventListener('transitionend', function once() {
                otherWrap.removeEventListener('transitionend', once);
                otherWrap.setAttribute('hidden', '');
              }, { once: true });
            }
          });
        }

        if (isOpen) {
          wrap.style.height = wrap.scrollHeight + 'px';
          requestAnimationFrame(() => { wrap.style.height = '0px'; });
          wrap.addEventListener('transitionend', function once() {
            wrap.removeEventListener('transitionend', once);
            wrap.setAttribute('hidden', '');
          }, { once: true });
          item.classList.remove('is-open');
          row.setAttribute('aria-expanded', 'false');
        } else {
          wrap.removeAttribute('hidden');
          wrap.style.height = wrap.scrollHeight + 'px';
          item.classList.add('is-open');
          row.setAttribute('aria-expanded', 'true');
          wrap.addEventListener('transitionend', function once() {
            wrap.removeEventListener('transitionend', once);
            wrap.style.height = 'auto';
          }, { once: true });
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_content_how_it_works"] && !Shopify.designMode) return;
  try {
    
(() => {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.18 });
  document.querySelectorAll('.hp-how').forEach((el) => obs.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_content_intro_pharmacy"] && !Shopify.designMode) return;
  try {
    
(() => {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.18 });
  document.querySelectorAll('.hp-intro-pharmacy').forEach((el) => obs.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_content_popular_products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.hp-pop').forEach((el) => obs.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_content_team_pharmacy"] && !Shopify.designMode) return;
  try {
    
(() => {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.hp-team').forEach((el) => obs.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_content_treatment_grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Reveal sections on scroll
  const sectionObs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        sectionObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.hp-treatment-grid').forEach((el) => sectionObs.observe(el));

  // Cursor-following 3D tilt + halo (desktop pointer only)
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || reduced) return;

  document.querySelectorAll('.hp-treatment-card').forEach((card) => {
    let rect = null;
    let raf = 0;

    const onEnter = () => { rect = card.getBoundingClientRect(); };
    const onMove = (e) => {
      if (!rect) rect = card.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        card.style.setProperty('--ry', `${(x - 0.5) * 6}deg`);
        card.style.setProperty('--rx', `${(0.5 - y) * 6}deg`);
        card.style.setProperty('--mx', `${x * 100}%`);
        card.style.setProperty('--my', `${y * 100}%`);
      });
    };
    const onLeave = () => {
      cancelAnimationFrame(raf);
      card.style.setProperty('--ry', '0deg');
      card.style.setProperty('--rx', '0deg');
      rect = null;
    };

    card.addEventListener('pointerenter', onEnter);
    card.addEventListener('pointermove', onMove);
    card.addEventListener('pointerleave', onLeave);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_effect_dual_marquee"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.hp-marquee-dual').forEach((root) => {
    const tracks = root.querySelectorAll('[data-marquee-track]');
    if (!tracks.length) return;

    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    const baseSpeed = parseFloat(root.dataset.baseSpeed || '0.6');
    const velEnabled = root.dataset.velocityEnabled !== 'false';

    const state = {
      offsets: Array.from(tracks).map(() => 0),
      scrollVel: 0,
      lastScroll: window.scrollY,
      lastTime: performance.now(),
    };

    if (velEnabled) {
      window.addEventListener('scroll', () => {
        const now = performance.now();
        const dt = Math.max(16, now - state.lastTime);
        const dy = window.scrollY - state.lastScroll;
        state.scrollVel = (dy / dt) * 16;
        state.lastScroll = window.scrollY;
        state.lastTime = now;
      }, { passive: true });
    }

    let raf = 0;
    const frame = () => {
      state.scrollVel *= 0.92;

      tracks.forEach((track, i) => {
        const dir = parseInt(track.getAttribute('data-dir') || '-1', 10);
        const speed = baseSpeed * dir + (velEnabled ? state.scrollVel * dir * 1.2 : 0);
        state.offsets[i] += speed;
        const w = track.scrollWidth / 2;
        if (state.offsets[i] <= -w) state.offsets[i] += w;
        if (state.offsets[i] >= 0 && dir === 1) state.offsets[i] -= w;
        track.style.transform = `translate3d(${state.offsets[i]}px,0,0)`;
      });
      raf = requestAnimationFrame(frame);
    };
    raf = requestAnimationFrame(frame);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_social_featured_in"] && !Shopify.designMode) return;
  try {
    
(() => {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });
  document.querySelectorAll('.hp-feat').forEach((el) => obs.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_social_reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.hp-reviews').forEach((el) => obs.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
